import React, { Fragment, useEffect, useState } from "react";
import moment from "moment";
import { fetchJson, post } from "../../lib/Fetching";
import Comments from "./Comments";
import Todos from "./Todos";
import { DefaultPaddedContainer } from "./Theme";
import NewCommentForm from "./NewCommentForm";
import SampleCaveatsView from "./sample_caveats/SampleCaveatsView";

export default function SampleComments({ sample_id, clientView, onChange }) {
  const [comments, setComments] = useState(false);
  const [sampleCaveats, setSampleCaveats] = useState(false);

  const fetchComments = () =>
    fetchJson("/registration/samples/" + sample_id + "/comments").then((json) => {
      if (json.error) alert(json.error);
      else setComments(json);
    });

  const fetchSampleCaveats = () => {
    fetchJson("/sample_testing/sample_caveats", { sample_id }).then((json) => {
      if (json.error) alert(json.error);
      else setSampleCaveats(json);
    });
  };

  useEffect(
    () => {
      fetchComments();
      fetchSampleCaveats();
    },
    [sample_id]
  );

  const handleSubmit = (comment) =>
    post("/registration/samples/" + sample_id + "/comments", comment)
      .then(fetchComments)
      .then(onChange)
      .catch((error) => alert(error));

  const handleExpire = (id) => {
    if (confirm(I18n.t("are_you_sure_you_want_to_delete_this_comment"))) {
      post("/registration/samples/" + sample_id + "/comments/" + id, {}, "DELETE")
        .then(fetchComments)
        .then(onChange)
        .catch((error) => alert(error));
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "flex-start",
        justifyContent: "center",
      }}
    >
      <DefaultPaddedContainer
        style={{
          width: 900,
          marginTop: 20,
          marginBottom: 20,
          marginRight: 20,
        }}
      >
        <h4 style={{ marginTop: 0, marginBottom: 20 }}>Comments</h4>
        {comments && (
          <Fragment>
            <Comments
              comments={comments}
              clientView={clientView}
              handleExpire={handleExpire}
            />
            <NewCommentForm handleSubmit={handleSubmit} clientView={clientView} />
          </Fragment>
        )}
      </DefaultPaddedContainer>
      <DefaultPaddedContainer
        style={{
          width: 600,
          marginTop: 20,
          marginBottom: 20,
          marginRight: 20,
        }}
      >
        <Todos sample_id={sample_id} clientView={clientView} onChange={onChange} />
      </DefaultPaddedContainer>
      {sampleCaveats &&
        (!clientView || sampleCaveats.length > 0) && (
          <DefaultPaddedContainer
            style={{
              width: 900,
              marginTop: 0,
              marginBottom: 20,
              marginRight: 20,
            }}
          >
            <SampleCaveatsView
              sample_id={sample_id}
              clientView={clientView}
              onChange={() => {
                onChange();
                fetchSampleCaveats();
              }}
              sampleCaveats={sampleCaveats}
            />
          </DefaultPaddedContainer>
        )}
    </div>
  );
}
